import { FontIcon } from '@fluentui/react';
import { Tooltip } from 'antd'
import React from 'react'


interface EditButtonProps {
  disabled?: boolean; 
}

function EditButton({ disabled }: EditButtonProps) {
  return (
    <Tooltip placement="bottom" title="Edit">
    <button
    disabled={disabled}
      className="button action">
       <FontIcon iconName="Edit"/>
    </button>
  </Tooltip>
  )
}

export default EditButton
